import React from "react";
import { Form, Button } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";

export default function RegistrationStepFour({
  data,
  incrementStep,
  decrementStep,
}) {
  const validationSchema = Yup.object().shape({
    otherPromotionals: Yup.string().required("Required"),
    otherPrecautions: Yup.string().required("Required"),
    otherInternetAccess: Yup.string().required("Required"),
    otherLeadSource: Yup.string().required("Required"),
    otherVolunteer: Yup.string().required("Required"),
    otherEthnicity: Yup.string().required("Required"),
  });

  return (
    <div className="registration-step-4">
      <h5 className="mb-3">Additional Information:</h5>
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={(values) => incrementStep(values)}
      >
        {({
          values,
          setFieldValue,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className="row g-0">
              <div className="col-md-6 pe-md-4 pe-0 mb-4">
                <div className="mb-4">
                  <Form.Label>
                    Would you allow your Child / Children to appear on camp
                    promotionals, electronic publications and event updates?
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    name="otherPromotionals"
                    id="otherPromotionalsYes"
                    label="Yes"
                    className="me-3"
                    value="yes"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherPromotionals", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <Form.Check
                    type="radio"
                    name="otherPromotionals"
                    id="otherPromotionalsNo"
                    label="No"
                    className="me-3"
                    value="no"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherPromotionals", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <ErrorMessage
                    name="otherPromotionals"
                    component="p"
                    className="error-message"
                  />
                </div>
                <div>
                  <Form.Label>How did you hear about the programme?</Form.Label>
                  <Form.Check
                    type="radio"
                    name="otherLeadSource"
                    id="leadsource1"
                    label="Email / Text from Bubbles & Smiles"
                    value="Email / Text from Bubbles & Smiles"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherLeadSource", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <Form.Check
                    type="radio"
                    name="otherLeadSource"
                    id="leadsource2"
                    label="Email / Text from my Child's School"
                    value="Email / Text from my Child's School"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherLeadSource", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <Form.Check
                    type="radio"
                    name="otherLeadSource"
                    id="leadsource3"
                    label="Local Authority"
                    value="Local Authority"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherLeadSource", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <Form.Check
                    type="radio"
                    name="otherLeadSource"
                    id="leadsource4"
                    label="Leaflet / Poster"
                    value="Leaflet / Poster"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherLeadSource", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <Form.Check
                    type="radio"
                    name="otherLeadSource"
                    id="leadsource5"
                    label="Family / Friend"
                    value="Family / Friend"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherLeadSource", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <Form.Check
                    type="radio"
                    name="otherLeadSource"
                    id="leadsource6"
                    label="Social Media"
                    value="Social Media"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherLeadSource", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <Form.Check
                    type="radio"
                    name="otherLeadSource"
                    id="leadsource7"
                    label="Other"
                    value="Other"
                    onChange={(e) =>
                      e.target.checked
                        ? setFieldValue("otherLeadSource", e.target.value)
                        : ""
                    }
                    disabled={isSubmitting}
                  />
                  <ErrorMessage
                    name="otherLeadSource"
                    component="p"
                    className="error-message"
                  />
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="mb-4">
                  <Form.Label>
                    Would you like your child / children to receive activity
                    packs and food recipe cards?
                  </Form.Label>
                  <div className="d-flex">
                    <Form.Check
                      type="radio"
                      name="otherPrecautions"
                      id="otherPrecautionsYes"
                      label="Yes"
                      className="me-3"
                      value="yes"
                      onChange={(e) =>
                        e.target.checked
                          ? setFieldValue("otherPrecautions", e.target.value)
                          : ""
                      }
                      disabled={isSubmitting}
                    />
                    <Form.Check
                      type="radio"
                      name="otherPrecautions"
                      id="otherPrecautionsNo"
                      label="No"
                      value="no"
                      onChange={(e) =>
                        e.target.checked
                          ? setFieldValue("otherPrecautions", e.target.value)
                          : ""
                      }
                      disabled={isSubmitting}
                    />
                  </div>
                  <ErrorMessage
                    name="otherPrecautions"
                    component="p"
                    className="error-message"
                  />
                </div>
                <div className="mb-4">
                  <Form.Label>
                    Do you have frequent access to the internet?
                  </Form.Label>
                  <div className="d-flex">
                    <Form.Check
                      type="radio"
                      name="otherInternetAccess"
                      id="otherInternetAccessYes"
                      label="Yes"
                      className="me-3"
                      value="yes"
                      onChange={(e) =>
                        e.target.checked
                          ? setFieldValue("otherInternetAccess", e.target.value)
                          : ""
                      }
                      disabled={isSubmitting}
                    />
                    <Form.Check
                      type="radio"
                      name="otherInternetAccess"
                      id="otherInternetAccessNo"
                      label="No"
                      value="no"
                      onChange={(e) =>
                        e.target.checked
                          ? setFieldValue("otherInternetAccess", e.target.value)
                          : ""
                      }
                      disabled={isSubmitting}
                    />
                  </div>
                  <ErrorMessage
                    name="otherInternetAccess"
                    component="p"
                    className="error-message"
                  />
                </div>
                <div className="mb-4">
                  <Form.Label>
                    We are looking for volunteers, would you like to volunteer?
                  </Form.Label>
                  <div className="d-flex">
                    <Form.Check
                      type="radio"
                      name="otherVolunteer"
                      id="otherVolunteer1"
                      label="Yes"
                      className="me-3"
                      value="yes"
                      onChange={(e) =>
                        e.target.checked
                          ? setFieldValue("otherVolunteer", e.target.value)
                          : ""
                      }
                      disabled={isSubmitting}
                    />
                    <Form.Check
                      type="radio"
                      name="otherVolunteer"
                      id="otherVolunteer2"
                      label="No"
                      value="no"
                      onChange={(e) =>
                        e.target.checked
                          ? setFieldValue("otherVolunteer", e.target.value)
                          : ""
                      }
                      disabled={isSubmitting}
                    />
                  </div>
                  <ErrorMessage
                    name="otherVolunteer"
                    component="p"
                    className="error-message"
                  />
                </div>
                <div>
                  <Form.Label>
                    For us to ensure all communities are well represented, what
                    is your ethnic background?
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="otherEthnicity"
                    placeholder="Enter your ethnic background"
                    value={values.otherEthnicity}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                  <ErrorMessage
                    name="otherEthnicity"
                    component="p"
                    className="error-message"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                className="me-2"
                onClick={() => decrementStep(values)}
                disabled={isSubmitting}
              >
                Back
              </Button>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                Done
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
